export const DeliveryType = {
  Shipping: 'shipping',
}
